<style src="./Button.scss" lang="scss"></style>

<script>
	/**
	 * The Button used on the Homepage.
	 * Can either be a real button or an a tag.
	 * @vue-prop {('' | 'submit')} [type=button] The type of the button to be created, not effective if url is set
	 * @vue-prop {string} [url] the url if the button should be a link
	 * @fires Button#click
	 */
	export default {
		name: 'HpButton',
		props: {
			type: {
				type: String,
				default: 'button'
			},
			url: String
		},
		methods: {
			clicked (event) {
				this.$emit('click', event);
			}
		}
	};
</script>

<template>
	<component data-component="button" :is="url ? 'a' : 'button'" :href="url || false" :type="url ? false : type" @click="clicked">
		<slot>Button</slot>
	</component>
</template>
